import StageButton from "./StageButton";

const StageSidebar = ({
    stages,
  stageMap,
  activeStageId,
  onStageChange,
}) => {
  return (
    <div className="w-[40%] flex flex-col gap-3">
      {stages.map((stage) => (
        <StageButton
          key={stage.id}
          stage={stage}
          status={stageMap[stage.id]?.status}
          isActive={activeStageId === stage.id}
          onClick={() => onStageChange(stage.id)}
        />
      ))}
    </div>
  );
};

export default StageSidebar;